/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Directory_Footer_CopyrightInputs */

const en_directory_footer_copyright = /** @type {(inputs: Directory_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Seek AI. All rights reserved.`)
};

const zh_directory_footer_copyright = /** @type {(inputs: Directory_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} Seek AI. 保留所有权利。`)
};

/**
* | output |
* | --- |
* | "© {year} Seek AI. All rights reserved." |
*
* @param {Directory_Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_copyright = /** @type {((inputs: Directory_Footer_CopyrightInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_CopyrightInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_copyright(inputs)
	return zh_directory_footer_copyright(inputs)
});
export { directory_footer_copyright as "directory.footer.copyright" }